export class UserPermissionsPolicy {
  repouser: boolean;
  tpsafeuser: boolean;
  tpdocumentationuser: boolean;
  tpiquser: boolean;

  constructor() {
    this.repouser = false;
    this.tpsafeuser = false;
    this.tpdocumentationuser = false;
    this.tpiquser = false;
  }
}

export const AllowedRoles = [
  'tpiquser',
  'tpiqsales',
  'psganalyst',
  'psgadmin',
  'transferpricing',
  'psgadmintransferpricing',
  'salestransferpricing',
  'psganalysttransferpricing'
];

export const AllowedLimitWordingRoles = [
  'psganalyst',
  'psgadmin',
  'psgadmintransferpricing',
  'psganalysttransferpricing'
];

export const AllowedRolesForNewUI = [
  'reportsonly',
  'documentationreview',
  'transferpricing',
  'salestransferpricing',
  'psganalysttransferpricing',
  'psgadmintransferpricing'
];
